import document from './document';

const paymentDocument = `
    amount
    document {
        ${document}
    }
    id
    ignored
    referenceId
    referenceType
`;

export default paymentDocument;
